import { gtmEvent } from '../../utils/gtmEvents';
const gtmTradeInOwing = (tradeInOwing) => {
    const gtmData = {
        event: 'add_trade_in',
        trade_in_owing: tradeInOwing,
    };
    gtmEvent(gtmData);
};
export default gtmTradeInOwing;
